import { createContext } from '@chakra-ui/react-utils';

interface PromptBarContext {
  placeholder: string;
  content: string;
  setContent: (content: string) => void;
  isDisabled: boolean;
  isSubmissionDisabled: boolean;
  isSubmitting: boolean;
  onSubmit?: () => void;
  isGenerating: boolean;
}

export const [PromptBarProvider, usePromptBarContext] =
  createContext<PromptBarContext>({
    name: 'PromptBarContext',
    errorMessage:
      'usePromptBarContext: `context` is undefined. Seems you used a PromptBar sub-component outside of a PromptBar wrapping box.',
  });
